var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showAddBtn":true,"showFilter":true,"showSearch":true,"showExportation":true},on:{"addEvent":function($event){return _vm.$router.push({ name: 'hospitalAddDoctor' })}}},[_vm._v("الاطباء")]),_c('main-table',{attrs:{"fields":_vm.fields,"query":"","list_url":"clinic/doctors"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }